/* =========================================================
   Samita Custom – Storefront-Anpassungen
   - "CHF x.xx / kg" Unit-Preis an Samitas Preis koppeln
   - B2B Steuer-/Versandtexte
   - Mengen-Step (+/- mit Mindestmenge) + Preisstaffel-Sync
   ========================================================= */
(function () {
  'use strict';

  // ---------- helpers ----------
  function parseNum(s) {
    var m = (s || '').match(/([\d.,]+)/);
    return m ? parseFloat(m[1].replace("'", '').replace(',', '.')) : null;
  }

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }


  // ---------- "CHF x.xx / kg" mit Samita-Preis synchronisieren ----------
  function updateUnitPrices() {
    document.querySelectorAll('[data-js-product-price-unit], .cart-item__unit-price').forEach(function (unitEl) {
      var block = unitEl.closest('.product-price, .product-item, .product-card, .product-item-compact, .cart-item, .cart-form-item, #AjaxCartSubtotal');
      if (!block) return;

      var origEl = block.querySelector('.samitaWS-customized-original-price');
      var newEl  = block.querySelector('.samitaWS-exclude-price, .samitaWS-customized-price');
      if (!origEl || !newEl) return;

      var unitMatch = unitEl.textContent.replace(/\s+/g, ' ').trim().match(/([\d.,]+)\s*\/\s*(.+)$/);
      if (!unitMatch) return;

      if (!unitEl.dataset.origUnitPrice) {
        unitEl.dataset.origUnitPrice = unitMatch[1].replace("'", '').replace(',', '.');
      }

      var orig = parseNum(origEl.textContent);
      var disc = parseNum(newEl.textContent);
      var origUnit = parseFloat(unitEl.dataset.origUnitPrice);
      if (!orig || !disc || !origUnit) return;

      var expected = 'CHF ' + (origUnit * (disc / orig)).toFixed(2) + ' / ' + unitMatch[2].trim();
      if (unitEl.textContent.trim().replace(/\s+/g, ' ') !== expected) {
        unitEl.textContent = expected;
      }
    });
  }


  // ---------- B2B Steuer-/Versandtexte ----------
  function fixTaxTexts() {
    if (!document.querySelector('.samitaWS-tax-excl, .samitaWS-exclude-price')) return;

    document.querySelectorAll('[data-product-policies]').forEach(function (el) {
      if (el.dataset.taxFixed) return;
      el.dataset.taxFixed = '1';
      el.innerHTML = 'exkl. MwSt.';
    });

    document.querySelectorAll('.cart__shipping').forEach(function (el) {
      if (el.dataset.taxFixed) return;
      el.dataset.taxFixed = '1';
      el.innerHTML = 'Exklusive Steuern. <a href="/policies/shipping-policy">Versand</a> wird beim Checkout berechnet';
    });
  }


  // ---------- Mengen-Inputs: step + min ----------
  function applyStepMin(input) {
    var step = parseInt(input.getAttribute('step'), 10) || 1;
    if (step <= 1) return;
    input.setAttribute('min', step);
    if ((parseInt(input.value, 10) || 0) < step) input.value = step;
  }

  function syncQuantityInputs() {
    document.querySelectorAll('input.qty-selector').forEach(function (input) {
      applyStepMin(input);
      if (input.dataset.qtyObserved) return;
      input.dataset.qtyObserved = '1';
      new MutationObserver(function () { applyStepMin(input); })
        .observe(input, { attributes: true, attributeFilter: ['step'] });
    });
  }

  // Minus-Button-Status nachziehen (z.B. nach Klick auf eine Samita-Staffelzeile)
  function refreshMinusDisabled() {
    document.querySelectorAll('product-quantity, .quantity-selector-holder').forEach(function (c) {
      var input = c.querySelector('input.qty-selector, input.product__quantity');
      var minus = c.querySelector('.qty-minus');
      if (!input || !minus) return;
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var val = parseInt(input.value, 10) || min;
      minus.classList.toggle('disabled', val <= min);
    });
  }

  // Click-Handler: +/- Buttons + Klicks auf Mengenstaffel-Zeilen
  document.addEventListener('click', function (e) {
    // Klick auf Staffelzeile -> Samita setzt die Menge, wir fixen nur den Button-Status
    if (e.target.closest('.volumeDisplayTableForm-options tbody tr')) {
      setTimeout(refreshMinusDisabled, 80);
      setTimeout(refreshMinusDisabled, 300);
      return;
    }

    var btn = e.target.closest('.qty-minus, .qty-plus');
    if (!btn) return;

    var container = btn.closest('product-quantity, .quantity-selector-holder');
    var input = container && container.querySelector('input.qty-selector');
    if (!input) return;

    var step = parseInt(input.getAttribute('step'), 10) || 1;
    var min  = parseInt(input.getAttribute('min'),  10) || step;
    var cur  = parseInt(input.value, 10) || min;

    // Theme-Verhalten nur ueberschreiben, wenn ein Step (>1) gesetzt ist
    if (step > 1) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('qty-plus'))  input.value = cur + step;
      else if (cur - step >= min)              input.value = cur - step;
    }

    // Samita zur Neuberechnung anstossen + Minus-Status aktualisieren
    setTimeout(function () {
      input.dispatchEvent(new Event('change', { bubbles: true }));
      refreshMinusDisabled();
    }, 50);
  }, true);


  // ---------- Beobachter ----------
  var refresh = debounce(function () {
    updateUnitPrices();
    fixTaxTexts();
  }, 60);

  function observeSamiPrices() {
    var els = document.querySelectorAll('.samitaWS-customized-price, .samitaWS-exclude-price, [samitaws-product-price]');
    if (!els.length) { setTimeout(observeSamiPrices, 500); return; }
    var obs = new MutationObserver(refresh);
    els.forEach(function (el) {
      obs.observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  function observeCart() {
    var roots = document.querySelectorAll('#AjaxCartForm, cart-form, .cart-form, .cart__items, #cart-drawer, .cart-drawer');
    if (!roots.length) { setTimeout(observeCart, 800); return; }
    var obs = new MutationObserver(refresh);
    roots.forEach(function (r) {
      obs.observe(r, { childList: true, subtree: true, characterData: true });
    });
  }


  // ---------- init ----------
  document.addEventListener('change', refresh);

  var ticks = 0;
  var initTimer = setInterval(function () {
    refresh();
    syncQuantityInputs();
    if (++ticks >= 20) clearInterval(initTimer);
  }, 200);

  setTimeout(observeSamiPrices, 1500);
  setTimeout(observeCart, 1500);
})();